var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "booking component",
      class: [{ "footer-active": _vm.footerActive }],
    },
    [
      _c("booking-header", {
        attrs: {
          languages: _vm.languages,
          "additional-data": _vm.bookingHeaderAdditionalData,
        },
      }),
      _vm._v(" "),
      _c("booking-progress-bar", { on: { edit: _vm.activate } }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c(
            "router-view",
            _vm._b(
              {
                staticClass: "booking-page",
                class: {
                  "--modify-booking-mode": _vm.isBookingEditMode,
                  "--is-multi-room": _vm.itemsInCart.length > 1,
                },
                on: {
                  "edit-query": _vm.activate,
                  "show-cart": function ($event) {
                    _vm.cartActive = true
                  },
                },
              },
              "router-view",
              _vm.bindings,
              false
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-bottom" } },
        [
          _c("booking-footer", {
            on: {
              edit: _vm.activate,
              "show-cart": function ($event) {
                _vm.cartActive = true
              },
            },
            model: {
              value: _vm.footerActive,
              callback: function ($$v) {
                _vm.footerActive = $$v
              },
              expression: "footerActive",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "overlay",
        { attrs: { "overlay-id": "check-availability", "content-width": 800 } },
        [
          _c("div", { staticClass: "overlay-wrapper" }, [
            _c("div", { staticClass: "overlay-image icon-fan-logo" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "overlay-title",
                attrs: { id: "check-availability-title" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.tc("booking.loadTitle")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "overlay-text",
                attrs: { id: "check-availability-description" },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.tc("booking.loadText")) + "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("cart-overlay", {
        attrs: { "is-active": _vm.cartActive },
        on: {
          "hide-cart": function ($event) {
            _vm.cartActive = false
          },
          edit: _vm.activate,
        },
      }),
      _vm._v(" "),
      _c(
        "booking-widget",
        _vm._b(
          { ref: "bookingWidget" },
          "booking-widget",
          Object.assign({}, _vm.$props, { dontRunConfig: true }),
          false
        )
      ),
      _vm._v(" "),
      _vm.isBookingEditMode ? _c("modify-logout-modal") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }